import React from "react";
import ListPagination from "../uiComponents/ListPagination";

// import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import { Create, FormDataConsumer, Datagrid, DateField, Edit, List, ReferenceInput, SelectInput, Show, Tab, TabbedShowLayout, TextField, TextInput, TabbedForm, FormTab, ArrayInput, SimpleFormIterator, DateInput, ImageField, NumberField, ArrayField, Filter, AutocompleteInput, RichTextField, ShowButton, EditButton, FunctionField } from 'react-admin';

import RecordSummery from "../components/recordSummery";
import ApplicationActions from "../components/applicationActions";
import RecordAvatar from "../uiComponents/RecordAvatar";
// import Typography from "@mui/material/Typography";
// import Box from "@mui/material/Box";
//
// import Card from "@mui/material/Card";
// import {uploadFile} from "../helpers/fileUpload";


// export const ReviewToolbar = props => (
//     <Toolbar {...props} >
//
//         <DeleteButton redirect={props.redirect}/>
//
//     </Toolbar>
// );




import moment from "moment";

import { FamilyForm, PersonalFormContent, PlaceFormContent, StoryContent, CustomToolbar, areasData } from "../helpers/commonForms";
const getInitials = (name) => {
    if (!name) return '?';
    return name.split(' ').filter(w => w.length > 0).slice(0, 2).map(w => w[0]).join('').toUpperCase();
};



const ApplicationFilter = (props) => (
    <Filter {...props}>
        <SelectInput alwaysOn  source="status" label='Status' choices={[
            {id: "Pending", name: 'Pending'},
            {id: "Waiting", name: 'Waiting'},
            {id: "Rejected", name: 'Rejected'},
            {id: "Accepted", name: 'Accepted'},
        ]}/>
        <SelectInput alwaysOn  source="placeType" label='Place Type' choices={[
            {id: "Orphanage", name: 'Orphanage'},
            {id: "Rental", name: 'Rental'},
            {id: "Private", name: 'Private'},
            {id: "Kebele", name: 'Kebele'},

        ]}/>
        <AutocompleteInput source="place.address.area" label="Area" choices={areasData.map(a => ({ id: a.area, name: a.area }))} />

        <ReferenceInput label="Applicant Name" source="_id" reference="Application" perPage={1000}>
            <AutocompleteInput  optionText="name" options={{ type: 'search' }}/>
        </ReferenceInput >

    </Filter>
)


export const ApplicationList= props => {
     return   <List perPage={50}  filterDefaultValues={{ status: 'Pending' }}  {...props} filters={<ApplicationFilter/>} pagination={<ListPagination />} sort={{ field: 'id', order: 'DESC' }}>
            <Datagrid rowClick='show'>
                <FunctionField label=" " sortable={false} render={record => (
                    <RecordAvatar record={record} alt={record.fullName} sx={{ width: 40, height: 40 }}>
                        {getInitials(record.fullName)}
                    </RecordAvatar>
                )} />
                <TextField source="fullName"/>

                <DateField label="Applied On" source="date"/>
                <TextField source="status"/>
                <ShowButton/>
                <EditButton/>
            </Datagrid>
        </List>
    }
;
export const ApplicationShow = props =>
    <Show {...props} queryOptions={{ refetchOnMount: true }}>
        <TabbedShowLayout >
            <Tab label="Summary">


                        <RecordSummery/>


                        <ApplicationActions/>





            </Tab>
            <Tab label="Personal">

                <TextField label="First Name" source="name" />
                <TextField label="Father Name"  source="fatherName"  />
                <TextField label="Grand Father Name" source="gFatherName" />
                <TextField  source="gender" />
                <DateField label="Birth Date" source="birthDate"/>
                <ImageField label="Photo"  source="photo" />

                <TextField label="Health Condition"  source="health.generalCondition"  />
                <TextField label="Health Remark"  source="health.remark"/>

                <TextField label="Level"  source="currentEducation.level"/>
                <TextField label="School Type"   source="currentEducation.schoolType" />
                <NumberField label="Grade"  source="currentEducation.grade"/>
                <TextField label="Distance From home (in Km)"  source="currentEducation.distance" />

            </Tab>
            <Tab label="Families">
                <ArrayField label='Family Member'  source="families">
                    <Datagrid>
                        <TextField  source="relationship" />
                        <TextField label="First Name" source="name" />
                        {/*<TextField  source="gender" />*/}
                        <DateField label="Birth Date" source="birthDate"/>
                        <ImageField label="Photo"  source="photo" />

                        <TextField label="Health Condition"  source="health.generalCondition"  />
                        <TextField label="Health Remark"  source="health.remark"/>
                        <TextField label="Phone"  source="address.phones[0].number"/>
                    </Datagrid>
                </ArrayField>
            </Tab>
            <Tab label="Place">
                <TextField label="Place Name" source="place.name" />
                <TextField  label="City"  source="place.address.city" />
                <TextField  label="Sub City"  source="place.address.subcity" />
                <TextField label="Woreda"  source="place.address.woreda" />
                <TextField label="Area"  source="place.address.area" />
                <TextField  label="House Number"  source="place.address.houseNumber" />
                <TextField  label="Location Text"  source="place.address.locationText" />
                <TextField label="Remark"  source="place.address.remark" />
            </Tab>
            <Tab label="Story">
                <RichTextField label="Story"  source="story.story" />
                <TextField label="Government Approved" source="story.governmentApproved" />
                <ArrayField label='Photos'  source="story.photos">
                    <Datagrid>
                        <TextField  source="title" />

                        <ImageField label="Photo"  source="filePath" />

                        <TextField label="Description"  source="description"  />

                    </Datagrid>
                </ArrayField>

            </Tab>
        </TabbedShowLayout>
    </Show>

// const CustomToolbar = withStyles(toolbarStyles)(props => {
//     const parent = props.record&&props.record.id?props.record.id:"create";
//     const history = useHistory();
//     const regex = '[^/]+(?=/$|$)'
//     const tab =( +history.location.pathname.match(regex)[0])||0;
//         return <Toolbar {...props}>
//             <div>
//             {!!tab&&<Button
//                 variant="contained"
//                 color="secondary"
//                 label="Prev" onClick={() => {
//
//                 history.push(tab - 1 ? (tab - 1).toString() : `../${parent}`)
//             }} startIcon={<BackIcon />}  />}
//             {tab<4&&<Button
//                 variant="contained"
//                 color="primary"
//
//                 label="Next" onClick={() => {
//
//                 history.push(tab ? (tab + 1).toString() : `${parent}/1`)
//             }} endIcon={<NextIcon />} />}
//             </div>
//             {((props.record&&props.record.id)||tab===4)&&<SaveButton/>}
//             {/*<DeleteButton undoable={false} />*/}
//         </Toolbar>
//     })
// ;

const ApplicationForm = props =>  <TabbedForm toolbar={<CustomToolbar tabs={5} {...props} />}  {...props} redirect='list'  >
    <FormTab label="Personal">
        <FormDataConsumer>
            {formDataProps => (
                <PersonalFormContent {...formDataProps}/>
            )}
        </FormDataConsumer>
    </FormTab>

        <FormTab   label="Family">
            <ArrayInput label='Family Member'  source="families">
                <SimpleFormIterator  >


                <FormDataConsumer>
                {formDataProps => (
                    <FamilyForm {...formDataProps}  />
                )}
                </FormDataConsumer>


                    {/*<Box display="flex" style={{width:"100%"}}>*/}
                    {/*    */}
                    {/*<TextInput label="Health Condition"  source="health.generalCondition" />*/}
                    {/*<TextInput label="Health Remark"  source="health.remark" />*/}
                    {/*</Box>*/}

                </SimpleFormIterator>
            </ArrayInput>
        </FormTab>


    <FormTab label="Place">
        <FormDataConsumer>
            {formDataProps => (
            <PlaceFormContent {...formDataProps}/>
            )}
        </FormDataConsumer>
    </FormTab>

    <FormTab label="Story">
        <StoryContent/>
    </FormTab>
        <FormTab   label="Application">
            <DateInput defaultValue={moment().format("MM-DD-YYYY")} label="Date" source="date" options={{ format: 'DD/MM/YYYY' }}/>
            <TextInput source="processedBy" />
        </FormTab>

    </TabbedForm>


export const ApplicationEdit = props => (
    <Edit {...props}>
        <ApplicationForm/>
    </Edit>
);

export const ApplicationCreate = props => (
    <Create {...props}>
        <ApplicationForm />
    </Create>
)

const Application = {list:ApplicationList,edit:ApplicationEdit,create:ApplicationCreate,show:ApplicationShow}

export default Application;
